interface HotkeyHintsProps {
  label: string
  items: readonly { key: string; action: string }[]
}

/** Shown only to devices with a precise pointer: phones have no keyboard to press. */
export function HotkeyHints({ label, items }: HotkeyHintsProps) {
  return (
    <p className="hidden flex-wrap items-center gap-x-3 gap-y-1 text-xs text-muted-foreground [@media(pointer:fine)]:flex">
      <span>{label}:</span>
      {items.map((item) => (
        <span key={item.key} className="inline-flex items-center gap-1.5">
          <kbd className="rounded border bg-muted px-1.5 py-0.5 font-mono text-[0.7rem] text-foreground">{item.key}</kbd>
          {item.action}
        </span>
      ))}
    </p>
  )
}
